import api from '../lib/api';

// Instances API (Admin Master only)
export const instancesAPI = {
  getAll: () => api.get('/instances'),
  getById: (id) => api.get(`/instances/${id}`),
  create: (data) => api.post('/instances', data),
  update: (id, data) => api.put(`/instances/${id}`, data),
  delete: (id) => api.delete(`/instances/${id}`),
  getMasterDashboard: () => api.get('/instances/dashboard/summary'),
};

export default instancesAPI;
